import { computed, Directive, input, InputSignal, Signal } from '@angular/core'
import { SpecialSymbolsEnum } from '@shared/constants/special-symbols.enum'

@Directive({
	selector: '[secret]',
	host: {
		'[class.secret]': 'isSecret()',
		'[attr.secret-elements]': 'isSecret() ? secret() : null',
		'[style.--secret-font-size]': 'secretFontSize()',
		'[style.font-size]': 'isSecret() ? "0 !important" : null',
	},
})
export class SecretDirective {
	protected readonly specialSymbolsEnum: typeof SpecialSymbolsEnum = SpecialSymbolsEnum

	public isSecret: InputSignal<boolean> = input<boolean>(false)
	public secretCount: InputSignal<number> = input<number>(6)
	public secretFontSize: InputSignal<string> = input<string>('10px')

	protected secret: Signal<string> = computed<string>((): string => {
		return this.specialSymbolsEnum.STAR.repeat(this.secretCount())
	})
}
